import { useCallback } from 'react';
import { SecondDoorContent } from 'shared/components/SecondDoorContent';
import { SECOND_GIFT_DOOR_LINK, TELEGRAM_HOSTS_LINK } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const SecondDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn, isDoorCompleted } = useDoorContent({
    doorCode: EAdventDoorsHashs.SecondDoor,
    giftLink: SECOND_GIFT_DOOR_LINK,
  });

  const handleOpenTelegramHostsLink = useCallback(() => {
    window.open(TELEGRAM_HOSTS_LINK, '_blank');
  }, []);

  return (
    <SecondDoorContent
      onClickBtn={handleOpenTelegramHostsLink}
      secondBtn={{ btnText: 'Забрать статью', onSecondBtn: handleClickBtn }}
      firstBtnClicked={isDoorCompleted}
      {...props}
    />
  );
};
